define('home/views/HideOnEndFooterView',[
    'home/views/common/FetchableCollectionFooterView',
], function (
    FetchableCollectionFooterView
) {
    'use strict';

    /**
     * A FetchableCollectionFooterView that only shows while there are
     * more pages to fetch. It will show a more button to kick off
     * another page load, and it will show a spinner while the next
     * page is being fetched. Once there are no more pages to fetch,
     * it will be hidden.
     */
    var HideOnEndFooterView = FetchableCollectionFooterView.extend({
        endOfItemsTemplate: function () {
            return '';
        },
    });

    return HideOnEndFooterView;
});

